import { render, staticRenderFns } from "./MailDistribution.vue?vue&type=template&id=ecb7b3b4"
import script from "./MailDistribution.vue?vue&type=script&lang=js"
export * from "./MailDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports